<template>
	
	<div style="width: 100%;">
		<One v-show="thisIndex === 0" :processData="processData" 
		:userDatas="userDatas" :deptDatas="deptDatas" :thisId="thisId" :success="success"></One>
		<Two v-show="thisIndex === 1" :processData="processData"
		:userDatas="userDatas" :deptDatas="deptDatas" :thisId="thisId" :success="success"></Two>
		<Three v-show="thisIndex === 2" :processData="processData"
		:userDatas="userDatas" :deptDatas="deptDatas" :thisId="thisId" :success="success"></Three>
		<Four v-show="thisIndex === 3" :processData="processData"
		:userDatas="userDatas" :deptDatas="deptDatas" :thisId="thisId" :success="success"></Four>
		<Four v-show="thisIndex === 4" :processData="processData"
		:userDatas="userDatas" :deptDatas="deptDatas" :thisId="thisId" :success="success"></Four>
	</div>
	
</template>

<script>
	import One from './ProcessOne.vue';
	import Two from './ProcessTwo.vue';
	import Three from './ProcessThree.vue';
	import Four from './ProcessFour.vue';
	export default{
		props: {
			processData: Object,
			userDatas: Array,
			deptDatas: Array,
			thisIndex: 0,
			thisId: Number,
			success: Function,
		},
		name: 'processWorkGovernChoose',
		components: {One, Two, Three, Four},
	}
</script>

<style>
</style>
